import { deleteField } from 'firebase/firestore';
import _ from 'lodash';
import { createFsDocKey } from '../../../global/firestoreData/appData/fsAppData';
import { realtimeDocumentTypes } from '../cnr/reducers/SportsEditMatchReducer';
import { _matchResultTypes } from '../cnr/reducers/SportsMatchReducer';
import { matchUpdateTypes } from '../cnr/reducers/SportsSeasonReducer';
import { seasonalUpdateTypes } from '../cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { sportsHelpers } from '../cnr/reducers/reducerHelpers/sportsHelpers';
import { realTimeScoring } from './realtimeScoring';
import { seasonalHelpers } from '../cnr/reducers/reducerHelpers/seasonalHelpers';

const _allowPendingMatchUpdates = true

export const updateTheMatch = (getUpdateProps, mainRt, matchProps) => {

  const {
    actionProps,
    appUserInfo,
    callback,
    currentUserId,
    database_fns,
    latestSeason,
    matchResultType,
    matchUpdateType,
    pathViews,
    sportDataSettings,
    sportPermissions,
    sportsKey,
    updateRtGameDayData,
  } = matchProps

  const { match_edit, match_rt, sortedAthletes, matches_playoffs } = actionProps ?? {}
  const { useRtGameDayData } = sportDataSettings

  let _useRtGameDayData

  let _match_current;

  switch (matchResultType) {
    case _matchResultTypes.realtime:
      _match_current = match_rt
      break;
    case _matchResultTypes.matchDay:
      _match_current = match_edit
      break;
    case _matchResultTypes.normal:
      _match_current = match_edit
      break;
    default:
    // nothing
  }

  const { _itemKey: _matchKey, _results, isPlayoff, startDate, startTime, location, home, away, _matchCollectionKey } = _match_current ?? {}
  const { score, scores, winner, loser } = _results ?? {}

  let _collectionName = isPlayoff ? 'playoffMatches' : 'matches'
  let _dataType = isPlayoff ? 'playoffMatches' : 'matches'
  let _collectionName_scores = isPlayoff ? 'playoffScores' : 'scores'
  let _dataType_scores = isPlayoff ? 'playoffScores' : 'scores'

  let _updateScoreCollection;

  const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])

  const matchData = {}
  const matchData_scores = {}

  if (_match_current && _matchKey) {

    const _mk = _dataType + '.' + _matchKey
    const _mk_scores = _dataType_scores + '.' + _matchKey

    if (!_match_current.teams && home.id && away.id) {
      matchData[_mk + '.teams'] = [home.id, away.id];
    }

    // depending of the matchUpdateType, modify the corresponding prop...

    switch (matchUpdateType) {
      case matchUpdateTypes.deleteRealtimeMatch:
        // do nothing here
        break;

      case matchUpdateTypes.deleteMatch:
        matchData[_mk] = deleteField();
        break;

      case matchUpdateTypes.removeResults:
        matchData[_mk + '.results'] = deleteField();
        break;

      case matchUpdateTypes.postponeMatch:
        matchData[_mk + '.postponed'] = true;
        matchData[_mk + '.cancelled'] = deleteField();
        break;

      case matchUpdateTypes.cancelMatch:
        matchData[_mk + '.cancelled'] = true;
        matchData[_mk + '.postponed'] = deleteField();
        break;

      case matchUpdateTypes.resetByeMatch:
        const { place, poolName, matchNumber } = _match_current.pending ?? {}
        const byeName = poolName + ' #' + matchNumber + '/' + place
        console.log('byeName', byeName)
        matchData[_mk + '.away'] = { id: _match_current.seeds.away, name: byeName };
        break;

      case matchUpdateTypes.updateMatchDetails:
        if (location) {
          matchData[_mk + '.location'] = location
        };
        matchData[_mk + '.startDate'] = startDate;
        matchData[_mk + '.startTime'] = startTime;
        matchData[_mk + '.postponed'] = deleteField();
        matchData[_mk + '.cancelled'] = deleteField();
        break;

      case matchUpdateTypes.updateMatchDayMatch:
        if (score || scores) {
          const res = {}

          if (scores) {
            if (_.isArray(scores)) {
              res.scores = _.compact(scores);
            } else {
              res.scores = scores;
            }
          }
          if (score) { res.score = score; }
          matchData[_mk + '.results'] = res;
          matchData_scores[_mk_scores] = { ...res };
        }
        break;

      case matchUpdateTypes.updateScore:

        _useRtGameDayData = useRtGameDayData && updateRtGameDayData

        if (score || scores) {

          const res = {}

          if (scores) {
            if (_.isArray(scores)) {
              res.scores = _.compact(scores);
            } else {
              res.scores = scores;
            }
          }
          if (score) { res.score = score; }

          let players;

          if (sortedAthletes) {
            players = {}
            sortedAthletes.forEach((sa, index) => {
              players[sa.key] = {
                firstName: sa.firstName,
                lastName: sa.lastName,
                position: index
              }
            })
            res.players = players
          }

          matchData[_mk + '.results'] = res;
          matchData_scores[_mk_scores] = { ...res };
          _updateScoreCollection = true
        }
        break;

      default:
        return;
    }

    // if useRtGameDayData (in settings) is true, only the realtime (matchDay) database will be updated

    const matchData_rt = {}
    if (scores) { matchData_rt.scores = scores; }
    if (score) { matchData_rt.score = score; }
    const rtProps = {
      appUserInfo,
      currentUserId,
      latestSeason,
      match_key: _matchKey,
      pathViews,
      realtimeDocumentType: realtimeDocumentTypes.matchDay,
      results: matchData_rt,
      seasonalUpdateType: seasonalUpdateTypes.matches,
      sportDataSettings,
      sportPermissions,
      callback,
    }

    const opts = { subDocumentKey: _matchCollectionKey, appUserInfo, rtProps }

    if (_useRtGameDayData) {
      return rtProps
      // realTimeScoring.updateRealtimeScoresToDatabase(mainRt, rtProps)
    } else {
      switch (matchUpdateType) {
        case matchUpdateTypes.deleteRealtimeMatch:
          // realTimeScoring.deleteRealtimeDatabaseScores(mainRt, sportPermissions, sportDataSettings, seasonalUpdateTypes.matches, pathViews, [_matchKey], appUserInfo, latestSeason)
          break;

        default:
          // sportPermissions, pks, callback, collectionName, documentFieldName, data, opts, dataInfos, _sportsYearAbr
          const _updateProps = getUpdateProps(sportPermissions, pks, callback, _collectionName, null, matchData, opts)

          return _updateProps
        // await update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps)

        // if (_updateScoreCollection) {
        //   const _updateProps2 = getUpdateProps(database_fns, sportPermissions, pathViews, pks, null, _collectionName_scores, null, matchData_scores, opts)
        //   await update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps2)
        // }

        // if (match_rt && sportPermissions.any && sportPermissions.matches) {
        //   // await deleteRealtimeDatabaseScores(pathViews, _matchKey, appUserInfo, latestSeason)
        // }

        // if (sportPermissions.any && sportPermissions.matches && isPlayoff && matches_playoffs && matchUpdateType === matchUpdateTypes.updateScore) {
        //   updatePendingMatch(update_seasonalOrGlobal, sportPermissions, pathViews, latestSeason, sportsKey, null, _match_current, matches_playoffs, winner, loser, _collectionName, callback)
        // }
      }
    }

    return {}
    // callback(matchProps)

  }
}


/**
 * Updates the next match of the team updated
 * @param {object} pathViews 
 * @param {string} latestSeason 
 * @param {string} dataType 
 * @param {object} match_edit 
 * @param {object} matches_playoffs 
 * @param {object} winner 
 * @param {string} altSeasonalName 
 * @param {func} callback 
 */
const updatePendingMatch = async (update_seasonalOrGlobal, database_fns, sportPermissions, pathViews, latestSeason, sportsKey, documentFieldName, match_edit, matches_playoffs, winner, loser, altSeasonalName, callback) => {

  const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey)

  const pendings = {
    levelMatchUpdates: {},
    matchWinners: {},
    matchLosers: {},
    results: {},
  }

  const { _matchCollectionKey } = sportsHelpers.getPendingMatchInfo(match_edit, matches_playoffs, pendings)

  const opts = { subDocumentKey: _matchCollectionKey }

  if (_allowPendingMatchUpdates) {
    const _updateProps = seasonalHelpers.getUpdateProps(database_fns, sportPermissions, pathViews, pks, callback, altSeasonalName, null, pendings.levelMatchUpdates, opts)
    update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps)
  } else {
    console.log('UPDATE THE PENDING MATCH')
    console.log('pks', pks)
    console.log('match_edit', match_edit)
    console.log('pendings', pendings)
    console.log('*****')
  }
}

/**
 * 
 * @param {object} match 
 * @param {string} teamType 
 * @param {string} oppType 
 * @param {object} matches_playoffs 
 * @param {string} levels 
 * @param {string} winner 
 * @param {string} data 
 */
export const getMatchData = (match, teamType, oppType, matches_playoffs, levels, winner, data) => {
  const { _itemKey } = match ?? {}
  let _playoffMatch = matches_playoffs[_itemKey]
  if (!_playoffMatch) {
    _playoffMatch = _.find(matches_playoffs, { _itemKey: _itemKey })
  }
  if (_playoffMatch) {
    const opponent = getOpponent(levels, matches_playoffs, _playoffMatch, oppType)
    data['matches.' + _itemKey + '.' + teamType] = winner;
    if (opponent) { data['matches.' + _itemKey + '.' + oppType] = opponent; }
  }
}

/**
 * 
 * @param {object} levels 
 * @param {object} matches_playoffs 
 * @param {string} homeOrAway 
 * @param {string} poolKey 
 * @param {number} originalSeed 
 * @returns the pending match
 * @description filters the playoff matches for a match on the `poolKey` and the `originalSeed`
 */
const getPendingMatch = (matches_playoffs, levels, homeOrAway, poolKey, originalSeed) => _.filter(matches_playoffs, function (pm) {
  const { pending, results } = pm
  return levels === pm.levels && pending &&
    (
      pending[homeOrAway].poolKey === poolKey &&
      (pending[homeOrAway].originalSeed === originalSeed)
    );
})

const getPendingMatches = (matches_playoffs, levels, poolKey) => _.filter(matches_playoffs, function (pm) {
  const { pending } = pm
  return pm && levels === pm.levels && pending && pending.away && pending.home && (pending.away.poolKey === poolKey || pending.home.poolKey === poolKey);
})

const getOriginalMatch = (levels, matches_playoffs, originalSeed) => _.filter(matches_playoffs, function (pm) {
  const { home } = pm
  return levels === pm.levels && home && (
    home.seed === originalSeed);
})

const getOpponent = (levels, matches_playoffs, playoffMatch, homeOrAway) => {
  const { pending: _pending } = playoffMatch
  const pendingTeam = _pending[homeOrAway]
  const { originalSeed } = pendingTeam
  const originalMatch = getOriginalMatch(levels, matches_playoffs, originalSeed)
  if (originalMatch && originalMatch.length === 1) {
    return originalMatch[0][homeOrAway]
  }
}

export const createNewMatch = async (update_seasonalOrGlobal, getUpdateProps, database_fns, sportPermissions, pathViews, latestSeason, sportsKey, actionProps, callback) => {

  const { match_edit } = actionProps ?? {}
  const { isPlayoff } = match_edit ?? {}

  const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey)

  const _matches = isPlayoff ? 'playoffMatches' : 'matches'
  const altSeasonalName = isPlayoff ? '_playoffs' : null

  if (match_edit) {
    const matchKey = database_fns.get_docKey('newMatch')
    const data = {}
    data[_matches + '.' + matchKey] = match_edit;
    const _updateProps = getUpdateProps(database_fns, sportPermissions, pathViews, pks, callback, 'matches', null, data)
    update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps, 'matches', null, data, callback)
  } else {
    console.log(match_edit)
  }
}

